"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _stencilReactDesc = require("@amzn/stencil-react-desc");

var _constants = require("../../button/constants");

var _context = require("../../context");

var _form = require("../../form");

var _layout = require("../../layout");

var _utils = require("../../utils");

var _utils2 = require("../time-picker/utils");

var _constants2 = require("../constants");

var _utils3 = require("../utils");

var _constants3 = require("./constants");

var _interfaces = require("./interfaces");

var _propTypes = require("./propTypes");

var _core = require("@emotion/core");

var _excluded = ["clearButtonAltText", "error", "isCalendarOpen", "locale", "maskPlaceholder", "onChange", "onError", "parentInsetElement", "setShouldFocusWithValue", "shouldFocusWithValue", "showMilliseconds", "showSeconds", "showTime", "value", "warning"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var DateInputFieldWithoutDocs = /*#__PURE__*/_react.default.forwardRef(function (_ref, ref) {
  var clearButtonAltText = _ref.clearButtonAltText,
      error = _ref.error,
      isCalendarOpen = _ref.isCalendarOpen,
      locale = _ref.locale,
      maskPlaceholder = _ref.maskPlaceholder,
      onChange = _ref.onChange,
      onError = _ref.onError,
      parentInsetElement = _ref.parentInsetElement,
      _ref$setShouldFocusWi = _ref.setShouldFocusWithValue,
      setShouldFocusWithValue = _ref$setShouldFocusWi === void 0 ? function () {
    return null;
  } : _ref$setShouldFocusWi,
      _ref$shouldFocusWithV = _ref.shouldFocusWithValue,
      shouldFocusWithValue = _ref$shouldFocusWithV === void 0 ? '' : _ref$shouldFocusWithV,
      showMilliseconds = _ref.showMilliseconds,
      showSeconds = _ref.showSeconds,
      showTime = _ref.showTime,
      value = _ref.value,
      warning = _ref.warning,
      forwardedProps = (0, _objectWithoutProperties2.default)(_ref, _excluded);

  var _useContext = (0, _react.useContext)(_context.StencilContext),
      stencilLocale = _useContext.locale;

  if (!locale) {
    locale = stencilLocale;
  }

  var dateFormat = (0, _utils2.getDefaultDateTimeFormat)((0, _utils3.getDateFormat)(locale), {
    showTime: showTime,
    showSeconds: showSeconds,
    showMilliseconds: showMilliseconds
  });
  var defaultDateFormat = (0, _utils2.getDefaultDateTimeFormat)(_constants2.DEFAULT_DATE_FORMAT, {
    showTime: showTime,
    showSeconds: showSeconds,
    showMilliseconds: showMilliseconds
  });

  if (!maskPlaceholder) {
    maskPlaceholder = dateFormat;
  } // Show mask only for full locales as it is not possible to handle cases when value may have different length


  var shouldShowMask = !!dateFormat.match(/MM/) && !!dateFormat.match(/DD/);

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      shouldFocusIfEmpty = _useState2[0],
      setShouldFocusIfEmpty = _useState2[1];

  var inputValue = ''; // Control the value which will be used in mount

  if (value) {
    // Check if it is a valid value, then convert it to desired format
    var valueFormatted = (0, _utils3.changeDateFormat)(value, defaultDateFormat, dateFormat);
    inputValue = !!valueFormatted ? valueFormatted : value;
  }

  var _useState3 = (0, _react.useState)(inputValue),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      internalInputValue = _useState4[0],
      setInternalInputValue = _useState4[1];

  var inputRef = (0, _react.useRef)(null);

  if (ref) {
    inputRef = ref;
  } // Will be used to understand whether changes is coming from input keydown


  var isChangedByKeyDown = (0, _react.useRef)(false); // Manage the value which is changed by typing or selecting, then set it to the state

  (0, _react.useEffect)(function () {
    if (isChangedByKeyDown.current) {
      isChangedByKeyDown.current = false;
      return;
    } // Check if it is a valid value and convert desired format


    var valueFormatted = (0, _utils3.changeDateFormat)(value, defaultDateFormat, dateFormat);
    setInternalInputValue(valueFormatted || inputValue);
  }, [inputValue, dateFormat, defaultDateFormat, value]);
  (0, _react.useEffect)(function () {
    if (shouldFocusWithValue.length > 0 && shouldFocusWithValue === value && internalInputValue === inputValue) {
      inputRef && inputRef.current && inputRef.current.focus();
      setShouldFocusWithValue('');
    }
  }, [inputValue, internalInputValue, setShouldFocusWithValue, shouldFocusWithValue, value]);
  (0, _react.useEffect)(function () {
    if (shouldFocusIfEmpty && internalInputValue === '' && inputRef && inputRef.current) {
      inputRef.current.focus();
      setShouldFocusIfEmpty(false);
    }
  }, [shouldFocusIfEmpty, internalInputValue]);

  var handleClearValue = function handleClearValue() {
    setInternalInputValue('');
    onChange && onChange('');
  };

  var handleBlur = function handleBlur() {
    isChangedByKeyDown.current = false;

    if (inputValue === dateFormat) {
      handleClearValue();
    }

    var valueFormatted = (0, _utils3.changeDateFormat)(inputValue, dateFormat, dateFormat);

    if (valueFormatted) {
      setInternalInputValue(valueFormatted);
    }
  };

  var handleChange = function handleChange(e, _, unformattedValue) {
    var newValue = e.target.value;
    isChangedByKeyDown.current = true;
    var isoDate = (0, _utils3.changeDateFormat)(newValue, dateFormat, defaultDateFormat);

    if (newValue.length > 0) {
      // Check whether the date is valid by attempting to parse it - this will
      if (!isoDate) {
        !!onError && onError(_interfaces.DateInputError.InvalidDate);
      }
    }

    var value = isoDate || unformattedValue;
    !!onChange && onChange(value);
    setInternalInputValue(newValue);
  };

  var handleClear = function handleClear() {
    handleClearValue();
    setShouldFocusIfEmpty(true);
  };

  var isClearButtonVisible = internalInputValue && !forwardedProps.disabled;
  var insetElement = {
    element: (0, _core.jsx)(_layout.Row, null, parentInsetElement, isClearButtonVisible && (0, _core.jsx)(_form.InputClearButton, {
      altText: clearButtonAltText,
      onClick: handleClear,
      tabIndex: isCalendarOpen ? -1 : undefined
    })),
    inset: _constants.BORDER_WIDTH * 2,
    width: _utils.A11Y_MIN_SIZE * (isClearButtonVisible && showTime ? 2 : 1)
  };

  var inputProps = _objectSpread({
    autoComplete: 'off',
    error: error,
    insetElementTrailing: insetElement,
    onBlur: handleBlur,
    onChange: handleChange,
    placeholder: maskPlaceholder,
    ref: inputRef,
    type: 'text',
    value: internalInputValue,
    warning: warning
  }, forwardedProps);

  if (showTime && showSeconds) {
    inputProps.minWidth = (showMilliseconds ? _constants3.INPUT_WITH_MS_MIN_WIDTH : _constants3.INPUT_WITH_SECONDS_MIN_WIDTH) + (isClearButtonVisible ? _utils.A11Y_MIN_SIZE : 0);
  }

  return shouldShowMask ? (0, _core.jsx)(_form.MaskedInput, (0, _extends2.default)({}, inputProps, {
    mask: (0, _utils3.getDateFormatMask)(maskPlaceholder),
    maskPlaceholder: maskPlaceholder
  })) : (0, _core.jsx)(_form.Input, inputProps);
});

var DateInputFieldWithDocs = (0, _stencilReactDesc.describe)(DateInputFieldWithoutDocs).description('Specialised text field for inputting dates.');
DateInputFieldWithDocs.propTypes = _propTypes.dateInputFieldPropTypes;
var DateInputField = (0, _utils.withTestAttributes)({
  component: 'StencilDateInputField'
})(DateInputFieldWithDocs);
DateInputField.displayName = 'DateInputField';
var _default = DateInputField;
exports.default = _default;